import Swiper from 'swiper'

export default class {
  constructor(element) {
    if (
      element.hasAttribute('data-length') &&
      Number(element.getAttribute('data-length')) > 1
    ) {
      this.initGallery(element)
    }
  }

  initGallery(element) {
    this.element = element
    this.nextElement = this.getElementOrNone('swiper-button-next')
    this.prevElement = this.getElementOrNone('swiper-button-prev')
    const pagination = this.getElementOrNone('swiper-pagination')
    this.options = {
      direction: 'horizontal',
      loop: true,
    }

    if (pagination) {
      this.options.pagination = {
        el: pagination,
        type: 'bullets',
        clickable: true,
      }
    }

    if (this.element.classList.contains('-hero')) {
      this.options.autoplay = {
        delay: 5000,
      }
      this.options.speed = 600
    }

    if (this.element.classList.contains('-keep-ratio')) {
      this.options.autoHeight = true
    }

    this.swiper = new Swiper(
      this.element.getElementsByClassName('swiper-container')[0],
      this.options,
    )

    this.nextElement.addEventListener('click', (e) => {
      this.swiper.slideNext()
    })
    this.prevElement.addEventListener('click', (e) => {
      this.swiper.slidePrev()
    })
  }

  getElementOrNone(selector) {
    const elements = this.element.getElementsByClassName(selector)
    if (elements[0]) {
      return elements[0]
    }
    return null
  }
}
